import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { FindInPageOutlined } from '@mui/icons-material';
import { usePMDetailsEditor } from '../../../../hooks/usePMDetailsEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const PMFindingsEditor: React.FC<Props> = ({ mode }) => {
  const { pmDetails, updatePMField } = usePMDetailsEditor(mode);

  const handleChange = (value: string) => {
    updatePMField({ findings: value });
  };

  return (
    <TextField
      label="Findings"
      value={pmDetails?.findings || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      multiline
      minRows={2}
      maxRows={4}
      placeholder="Enter findings from PM inspection"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FindInPageOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PMFindingsEditor;
